import { useState } from "react"
import { Badge } from "@/components/ui/badge"
import { Input } from "@/components/ui/input"
import { X } from "lucide-react"

interface ComplianceTagEditorProps {
  tags: string[]
  onChange: (tags: string[]) => void
}

export function ComplianceTagEditor({ tags, onChange }: ComplianceTagEditorProps) {
  const [input, setInput] = useState("")

  const addTag = () => {
    const tag = input.trim().toUpperCase()
    if (tag && !tags.includes(tag)) {
      onChange([...tags, tag])
    }
    setInput("")
  }

  const removeTag = (tag: string) => {
    onChange(tags.filter((t) => t !== tag))
  }

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-muted-foreground">
        Compliance Tags
      </label>
      <div className="flex flex-wrap gap-1.5">
        {tags.map((tag) => (
          <Badge key={tag} variant="outline" className="gap-1 pr-1">
            {tag}
            <button
              type="button"
              onClick={() => removeTag(tag)}
              className="ml-0.5 rounded-sm hover:bg-muted p-0.5"
            >
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            addTag()
          }
        }}
        placeholder="Type a tag and press Enter (e.g. HIPAA, FDA)"
        className="max-w-xs text-sm"
      />
    </div>
  )
}
